"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PIDependencies = void 0;

var _dependenciesPiGenerated = require("./dependenciesPi.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var PIDependencies = {
  piDependencies: _dependenciesPiGenerated.piDependencies,
  createUppercasePi: _factoriesAny.createUppercasePi
};
exports.PIDependencies = PIDependencies;